import { usePageData } from '@composables/usePageData';
import { useBrand } from '@composables/useBrand';
import { useSlideout } from '@composables/utils/useSlideout';
import { fireLinkTag } from '../features/analytics/tagManager';

const EVENT_NAME = 'close:add to registry overlay';
const REGISTRY_TITLE = 'Add to Registry';
/**
 * Composable for add to registry analytics
 */
const useATRAnalytics = () => {
  const { isBcom } = useBrand();
  const { productId, deviceType } = usePageData();
  const { slideout, isSlideoutAvailable } = useSlideout();
  /**
     * Fires analytics on ATR slideout close
     */
  const fireAnalyticsOnATRClose = () => {
    if (
      !isBcom
            || !isSlideoutAvailable.value
            || slideout.value.title !== REGISTRY_TITLE
    ) {
      return;
    }
    const payload = {
      event_name: EVENT_NAME,
      product_id: [productId],
      site_type: (deviceType ?? '').toLowerCase(),
    };

    fireLinkTag(payload);
  };

  return {
    fireAnalyticsOnATRClose,
  };
};

export default useATRAnalytics;

export { useATRAnalytics };
